// notas
// falta crear notas del cliente y empresa al crear la cotizacion

import { useCallback, useEffect, useState } from "react";
import { etiquetas, logos } from "../../../hook/Arreglos";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { jsPDF } from "jspdf";
import "./style.css";
import Swal from "sweetalert2"; // Importar SweetAlert2
import { cambioEstadoCotizacion, eliminarCotizacion, traerSalones } from "../../../store/cotizaciones/thunkCotizaciones";
import Select from "react-select";
import { extraerContratoId } from "../../../store/contratos/thunkContratos";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PDFDownload from "./PDFGenerator";
import { PoliticasLargas } from "./PoliticasLargas";
import { PoliticasCorta } from "./PoliticasCorta";
import PDFGeneratorCorto from "./PDFGeneratorCorto";

// Función para formatear la fecha a la hora local de Costa Rica
const formatearFecha = (fecha) =>
    fecha
        ? new Date(fecha).toLocaleString("es-ES", {
              timeZone: "America/Costa_Rica", // Zona horaria de Costa Rica
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
              year: "numeric",
              month: "long",
              day: "numeric",
              weekday: "long",
          })
        : "N/D";

const estadosEvento = [
    { id_estado: 1, nombre_estado: "Cotizacion Confirmada", color_estado: "#A1E450", status_estado: 1 }, // Evento confirmado (color verde)
    { id_estado: 2, nombre_estado: "Cotizacion Tentativa", color_estado: "#C5BED1", status_estado: 1 }, // Evento tentativo (color gris)
    { id_estado: 3, nombre_estado: "Cotizacion Perdida", color_estado: "#c4144c", status_estado: 1 }, // Evento interno (color azul)
    { id_estado: 4, nombre_estado: "Cotizacion Enviada", color_estado: "#000", status_estado: 1 }, // Evento interno (color azul)
];

export const VerContrato = () => {
    // Hook para navegar entre rutas de la aplicación
    const navigate = useNavigate();

    // Hook para interactuar con el estado global (Redux)
    const dispatch = useDispatch();

    // Estado local para almacenar los datos del formulario relacionados con el contrato
    const [formulario, setFormulario] = useState({
        // Información general
        fechaCreacion: "", // Fecha de creación del formulario
        nombreCliente: "", // Nombre del cliente
        correoCliente: "", // Correo electrónico del cliente
        telefonoCliente: "", // Teléfono de contacto del cliente
        nombreEjecutivo: "", // Nombre del ejecutivo asignado al cliente
        cargoEjecutivo: "", // Cargo del ejecutivo asignado
        correoEjecutivo: "", // Correo electrónico del ejecutivo asignado
        telefonoEjecutivo: "", // Teléfono del ejecutivo asignado

        // Detalles del evento y cotización
        consecutivo: "", // Número único o consecutivo del formulario
        nombreEvento: "", // Nombre del evento asociado al contrato
        MonedaTipo: [
            // Lista de tipos de moneda disponibles
            { id: 1, nombre: "$", estado: false }, // Dólares
            { id: 2, nombre: "¢", estado: false }, // Colones
        ],
        hotelSeleccionado: "", // Identificador del hotel seleccionado
        empresaSeleccionada: "", // Identificador de la empresa seleccionada
        fechaSeleccionadas: "Sin definir", // Fechas definidas para el evento
        requerimientos: [], // Lista de requerimientos específicos del cliente
        otroServicios: [], // Servicios adicionales contratados
        requerimientoshabitaciones: [], // Requerimientos específicos de habitaciones
        totalRequerimientos: [], // Suma de los requerimientos detallados
        totalGlobalCotizacion: 0, // Monto total de la cotización
        notaCoti: "", // Notas adicionales relacionadas con la cotización

        // Información del evento y contrato
        tokenEvento: "", // Identificador único o token del evento
        estadoCotizacion: "", // Estado actual de la cotización (pendiente, aceptada, rechazada, etc.)
        celebro_contrato: "", // Estado de ejecución del contrato
        cedula_contrato: "", // Cédula o documento de identificación asociado al contrato
        empresaC_contrato: "", // Empresa responsable en el contrato
        hotelC_contrato: "", // Hotel asociado al contrato
        formapago_contrato: "", // Forma de pago acordada en el contrato
        admin_fecha: "", // Fecha registrada por el administrador
        admin_name: "", // Nombre del administrador que gestiona el contrato
        admin_hotel: "", // Hotel administrado por el administrador
        garantia_contrato: "", // Información sobre la garantía del contrato
    });

    // Estado local para controlar si se está descargando el PDF
    const [isDownloading, setIsDownloading] = useState(false);

    // Función para asignar el logo correspondiente a un hotel
    const asignarLogo = (idHotel) => {
        // Buscar el hotel correspondiente en la lista de logos
        const hotel = logos.find((item) => item.id === Number(idHotel));
        // Devolver el logo encontrado o uno predeterminado
        return hotel ? hotel.logo : "/assets/logo2.jpg";
    };

    // Función para obtener un parámetro "data" desde la URL
    const getIdFromUrl = useCallback(() => {
        // Crear una instancia de URLSearchParams con la URL actual
        const params = new URLSearchParams(location.search);
        // Devolver el valor del parámetro "data"
        return params.get("data");
    }, [location.search]);

    // Función para obtener los salones disponibles desde la API, dado un hotel y una lista de salones
    const fetchSalonesAPI = useCallback(
        async (hotelValue, idSalones) => {
            try {
                const salones = await dispatch(traerSalones({ idHotel: hotelValue }));

                // Filtrar los salones con los ids proporcionados
                const salonesFiltrados = salones.filter((salon) => idSalones.includes(salon.id_salon));

                // Extraer los nombres de los salones filtrados
                const nombresSalones = salonesFiltrados.map((salon) => salon.nombre_salon);

                // Unir los nombres de los salones en un string
                const nombresConcatenados = nombresSalones.join(", ");

                return nombresConcatenados;
            } catch (error) {
                console.error("Error en fetchSalonesAPI:", error);
                return "Sin definir"; // Retornar "Sin definir" si hay error
            }
        },
        [dispatch],
    );

    // Asegúrate de que esta función esté definida antes de procesar los requerimientos
    const obtenerSalon = async (req) => {
        // Si no hay salones, retornar "Sin definir"
        if (req.salones_req_con.length === 0) return "Sin definir";

        const hotelId = req.hotelid || "200"; // Si no hay hotel, usamos "200" por defecto

        return await fetchSalonesAPI(hotelId, req.salones_req_con); // Obtener el salón de la API
    };

    // Función para procesar los requerimientos, devolviendo un arreglo de promesas
    const procesarRequerimientos = async (requerimiento) => {
        return await Promise.all(
            requerimiento.map(async (req) => {
                const salon = await obtenerSalon(req);

                // Devolver un objeto con los datos del requerimiento
                return {
                    id: req.id_req_con,
                    hotel: req.hotelid || "",
                    hora: req.hora_req_con,
                    fecha: [req.fecha_req_con],
                    cantidad: parseInt(req.pax_req_con),
                    articulos: req.articulo_req_con,
                    descripcionArticulo: req.dec_req_con.trim(),
                    dias: parseInt(req.dias_req_con),
                    salon: salon || "Sin definir", // Asignar salón
                    precio: req.precio_req_con,
                    subtotal: req.subtotal_req_con,
                    articulosOptions: [], // Opciones de artículos (vacío por ahora)
                    salonOptions: [], // Opciones de salones (vacío por ahora)
                };
            }),
        );
    };

    // Función para extraer los datos de la contrato desde la API
    const extarerDatosContrato = useCallback(async () => {
        try {
            // Mostrar el alerta de "Cargando..."
            Swal.fire({
                title: "Cargando...",
                text: "Espera mientras cargamos los datos",
                allowOutsideClick: false, // Evitar que el usuario cierre el alert
                didOpen: () => {
                    Swal.showLoading(); // Mostrar el spinner de carga
                },
            });
            // Obtener el ID desde la URL
            const ids = getIdFromUrl();

            // Hacer la solicitud para obtener los datos de la contrato desde la API
            const resul = await dispatch(extraerContratoId(ids));

            // Extraer la primera contrato de la respuesta
            const resultado = resul.contrato.data[0];

            // Extraer los datos de los requerimientos, otros servicios, habitaciones y el total de requerimientos
            const requerimiento = resul.requerimientos.data || [];
            const otrosServ = resul.otrosServicios.data || [];
            const habit = resul.habitaciones.data || [];

            const total_requerimientos = resul.totalRequerimientos.data["0"] || [];

            // Verificar si la contrato existe
            if (!resultado) {
                console.error("No se encontró la contrato.");
                return;
            }

            // Procesar los requerimientos y otros servicios si existen
            const requerimientosResult = requerimiento.length > 0 ? await procesarRequerimientos(requerimiento) : [];
            const OtroServiciosResult = otrosServ.length > 0 ? await procesarRequerimientos(otrosServ) : [];

            // Seleccionar la moneda activa (¢ o $) basado en el valor de la contrato
            const monedaSeleccionada = resultado.moneda_contrato === 0 ? { id: 1, nombre: "$", estado: true } : { id: 2, nombre: "¢", estado: true };

            const limpiarSubtotal = (valor) => parseFloat((valor || "").toString().replace(/[^0-9.]/g, "")) || 0;

            const formatter = new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            const totalMonto =
                limpiarSubtotal(total_requerimientos.totalReq_Subt_con) +
                limpiarSubtotal(total_requerimientos.totalOtro_Subt_con) +
                limpiarSubtotal(total_requerimientos.totalsubtRoom_Subt_con);

            const diasSemana = ["Dom", "Lun", "Mar", "Mier", "Jue", "Vie", "Sab"];
            const meses = [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
            ];
            const hoy = new Date();

            const fechaFormato = diasSemana[hoy.getDay()] + " " + hoy.getDate() + " de " + meses[hoy.getMonth()] + " " + hoy.getFullYear();

            // Actualizar el estado del formulario con los datos obtenidos de la contrato
            setFormulario((prev) => ({
                ...prev,
                consecutivo: resultado.id_consecutivo_contrato, // Consecutivo de la contrato
                estadoCotizacion: resultado.Estado_contrato, // Consecutivo de la contrato
                hotelSeleccionado: resultado.id_hotel_contrato, // ID del hotel seleccionado
                fechaCreacion: formatearFecha(resultado.fecha_creacion_contrato), // Fecha de creación de la contrato
                fechaSeleccionadas: resultado.fecha_evento_contrato || "Sin definir", // Fecha del evento o valor por defecto
                nombreEvento: resultado.nombre_evento_contrato, // Nombre del evento
                nombreCliente: resultado.nombre_cliente || "Sin definir", // Nombre del cliente o valor por defecto
                correoCliente: resultado.correo_cleinte || "Sin definir", // Correo del cliente o valor por defecto
                telefonoCliente: resultado.telefono_cliente || "Sin definir", // Teléfono del cliente o valor por defecto
                nombreEjecutivo: resultado.name_admin || "Sin definir", // Nombre del ejecutivo o valor por defecto
                cargoEjecutivo: resultado.puesto || "Sin definir", // Cargo del ejecutivo o valor por defecto
                correoEjecutivo: resultado.email_admin || "Sin definir", // Correo del ejecutivo o valor por defecto
                telefonoEjecutivo: resultado.phone_admin || "Sin definir", // Teléfono del ejecutivo o valor por defecto
                requerimientos: requerimientosResult, // Lista de requerimientos procesados
                otroServicios: OtroServiciosResult, // Lista de otros servicios procesados
                empresaSeleccionada: resultado.nombre_empresa, // Nombre de la empresa seleccionada
                totalRequerimientos: total_requerimientos, // Total de los requerimientos
                requerimientoshabitaciones: habit, // Habitaciones solicitadas
                MonedaTipo: prev.MonedaTipo.map((moneda) =>
                    moneda.id === monedaSeleccionada.id ? { ...moneda, estado: true } : { ...moneda, estado: false },
                ), // Actualizar el estado de la moneda seleccionada
                notaCoti: resultado.nota_contrato || "", // Nota de la contrato o valor por defecto
                tokenEvento: resultado.ReferenciaEvento, // Token único del evento
                totalGlobalCotizacion: formatter.format(totalMonto),

                celebro_contrato: resultado.celebro_contrato,
                cedula_contrato: resultado.cedula_contrato,
                empresaC_contrato: resultado.empresaC_contrato,
                hotelC_contrato: resultado.hotelC_contrato,
                formapago_contrato: resultado.formapago_contrato,
                admin_fecha: fechaFormato,
                admin_name: resultado.name_admin,
                admin_hotel: resultado.hotelC_contrato,
                garantia_contrato: resultado.garantia_contrato,
                dato1_contrato: resultado.dato1_contrato,
                dato2_contrato: resultado.dato2_contrato,
            }));
            Swal.close();
        } catch (error) {
            // Manejo de errores en caso de fallos en la solicitud de la contrato
            console.error("Error al obtener los datos de contrato:", error);
            Swal.close();
        }
    }, [dispatch]); // Dependencia de la función useCallback

    // Hook para ejecutar una acción al montar el componente
    useEffect(() => {
        extarerDatosContrato(); // Extraer datos de la contrato
    }, []);

    const EditarCotizacion = () => {
        const ids = getIdFromUrl();
        navigate(`/contratos/editar?data=${ids}`); // Navegación a otra vista
    };

    /**
     * Obtiene el símbolo de la moneda activa (la que tenga estado: true).
     * Por defecto es "$" si no se encuentra otra activada.
     */
    const monedaActiva = formulario.MonedaTipo.find((moneda) => moneda.estado)?.nombre || "$";

    // Estado para controlar la visualización de las políticas
    const [mostrarPoliticasCortas, setMostrarPoliticasCortas] = useState(false);

    // Función para manejar el cambio del checkbox
    const manejarCambioPoliticas = (e) => {
        setMostrarPoliticasCortas(e.target.checked);
    };

    return (
        <>
            <div id="cotizacion-contenido" className={`g-3 row ${isDownloading ? "col-12" : "col-12"}`} style={{ fontSize: "13pt" }}>
                <div className="col-12">
                    <div className="row align-items-center g-3">
                        <div className="col-sm-12">
                            <div className="d-flex align-items-center mb-2">
                                <img
                                    alt="images"
                                    loading="lazy"
                                    width="160"
                                    height="28"
                                    decoding="async"
                                    className="img-fluid"
                                    src={asignarLogo(formulario.hotelSeleccionado)}
                                    style={{ verticalAlign: "middle" }} // Alineación vertical
                                />
                                <h2 className="mb-0 ms-auto" style={{ marginTop: "50px" }}>
                                    #{formulario.consecutivo}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-4">
                    <div className="border rounded p-4 shadow-sm bg-light">
                        <h4 className="mb-3 text-dark font-weight-bold small-title">Información del Ejecutivo</h4>

                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Ejecutiva: <strong>{formulario.nombreEjecutivo}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Cargo: <strong>{formulario.cargoEjecutivo}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Correo Electrónico: <strong>{formulario.correoEjecutivo}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div>
                            <h5 className="mb-1 text-grey small-text">
                                Teléfono: <strong>{formulario.telefonoEjecutivo}</strong>
                            </h5>
                        </div>
                    </div>
                </div>

                <div className="col-sm-4">
                    <div className="border rounded p-4 shadow-sm bg-light">
                        <h4 className="mb-3 text-dark font-weight-bold small-title">Información del Cliente</h4>

                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Empresa: <strong>{formulario.empresaSeleccionada}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Cliente: <strong>{formulario.nombreCliente}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Correo Electrónico: <strong>{formulario.correoCliente}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div>
                            <h5 className="mb-1 text-grey small-text">
                                Teléfono: <strong>{formulario.telefonoCliente}</strong>
                            </h5>
                        </div>
                    </div>
                </div>

                <div className="col-sm-4">
                    <div className="border rounded p-4 shadow-sm bg-light">
                        <h4 className="mb-3 text-dark font-weight-bold small-title">Información de contrato</h4>

                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Número contrato: <strong>#{formulario.consecutivo}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Fecha contrato: <strong>{formulario.fechaCreacion}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Fechas Evento: <strong>{formulario.fechaSeleccionadas || "Sin definir"}</strong>
                            </h5>
                        </div>
                        <hr />
                        <div className="mb-3">
                            <h5 className="mb-1 text-grey small-text">
                                Nombre Evento: <strong>{formulario.nombreEvento}</strong>
                            </h5>
                        </div>
                    </div>
                </div>

                {formulario.requerimientos.length > 0 && (
                    <div className="col-12">
                        <div
                            style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }}
                            className="alert alert-secondary small-title"
                            role="alert"
                        >
                            REQUERIMIENTO DE EVENTO
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover mb-0 custom-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "1%" }}>#</th>
                                        <th style={{ width: "7%" }}>Fecha</th>
                                        <th style={{ width: "1%" }}>Hora</th>
                                        <th style={{ width: "1%" }}>Cant.</th>
                                        <th style={{ width: "15%" }}>Desc. artículo</th>
                                        <th style={{ width: "1%" }}>Días</th>
                                        <th style={{ width: "5%" }}>Salones</th>
                                        <th style={{ width: "1%" }}>Precio {monedaActiva}</th>
                                        <th style={{ width: "1%" }}>Subto. {monedaActiva}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formulario.requerimientos.map((requerimiento, index) => (
                                        <tr key={index} style={{ textAlign: "justify" }}>
                                            <td style={{ fontSize: "13px" }}>{index + 1}</td> {/* Se suma 1 al índice */}
                                            <td style={{ fontSize: "13px" }}>
                                                {
                                                    typeof requerimiento.fecha === "string"
                                                        ? requerimiento.fecha.split(",").map((part, idx) => (
                                                              <span key={idx}>
                                                                  {part.trim()}
                                                                  <br />
                                                              </span> // Se agrega un <br /> por cada coma
                                                          ))
                                                        : requerimiento.fecha // Si no es string, se muestra tal cual
                                                }
                                            </td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.hora === "NLL" ? "Sin definir" : requerimiento.hora}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.cantidad}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.descripcionArticulo}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.dias}</td>
                                            <td style={{ fontSize: "13px" }}>
                                                {requerimiento.salon
                                                    ? requerimiento.salon.includes(",")
                                                        ? requerimiento.salon.split(",").map((parte, index) => (
                                                              <span key={index}>
                                                                  {parte.trim()}
                                                                  <br />
                                                              </span>
                                                          ))
                                                        : requerimiento.salon
                                                    : "Sin definir"}
                                            </td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.precio}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.subtotal}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="text-start">
                            <hr className="mb-2 mt-1 border-secondary border-opacity-50" />
                        </div>
                    </div>
                )}
                {formulario.requerimientos.length > 0 && (
                    <div className="col-12">
                        <div className="invoice-total ms-auto invoiceRequerimiento">
                            {/* Bloque Subtotal */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>SUB TOTAL {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.subtReq_Subt_con}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>13% IM.VENTAS {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.treceReq_Subt_con}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>10% IMP.SERV {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.diezReq_Subt_con}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>TOTAL A&B {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.totalReq_Subt_con}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {formulario.otroServicios.length > 0 && (
                    <div className="col-12">
                        <div
                            style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }}
                            className="alert alert-secondary small-title"
                            role="alert"
                        >
                            OTROS SERVICIOS
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover mb-0 custom-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "1%" }}>#</th>
                                        <th style={{ width: "7%" }}>Fecha</th>
                                        <th style={{ width: "1%" }}>Hora</th>
                                        <th style={{ width: "1%" }}>Cant.</th>
                                        <th style={{ width: "15%" }}>Desc. artículo</th>
                                        <th style={{ width: "1%" }}>Días</th>
                                        <th style={{ width: "5%" }}>Salones</th>
                                        <th style={{ width: "1%" }}>Precio {monedaActiva}</th>
                                        <th style={{ width: "1%" }}>Subto. {monedaActiva}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formulario.otroServicios.map((requerimiento, index) => (
                                        <tr key={index} style={{ textAlign: "justify" }}>
                                            <td style={{ fontSize: "13px" }}>{index + 1}</td> {/* Se suma 1 al índice */}
                                            <td style={{ fontSize: "13px" }}>
                                                {
                                                    typeof requerimiento.fecha === "string"
                                                        ? requerimiento.fecha.split(",").map((part, idx) => (
                                                              <span key={idx}>
                                                                  {part.trim()}
                                                                  <br />
                                                              </span> // Se agrega un <br /> por cada coma
                                                          ))
                                                        : requerimiento.fecha // Si no es string, se muestra tal cual
                                                }
                                            </td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.hora === "NLL" ? "Sin definir" : requerimiento.hora}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.cantidad}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.descripcionArticulo}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.dias}</td>
                                            <td style={{ fontSize: "13px" }}>
                                                {requerimiento.salon
                                                    ? requerimiento.salon.includes(",")
                                                        ? requerimiento.salon.split(",").map((parte, index) => (
                                                              <span key={index}>
                                                                  {parte.trim()}
                                                                  <br />
                                                              </span>
                                                          ))
                                                        : requerimiento.salon
                                                    : "Sin definir"}
                                            </td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.precio}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.subtotal}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="text-start">
                            <hr className="mb-2 mt-1 border-secondary border-opacity-50" />
                        </div>
                    </div>
                )}
                {formulario.otroServicios.length > 0 && (
                    <div className="col-12">
                        <div className="invoice-total ms-auto invoiceRequerimiento">
                            {/* Bloque Subtotal */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>SUB TOTAL {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.subtOtro_Subt_con}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>13% IM.VENTAS {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.treceOtro_Subt_con}</p>
                                </div>
                            </div>

                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>TOTAL MONTAJE {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.totalOtro_Subt_con}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {formulario.requerimientoshabitaciones.length > 0 && (
                    <div className="col-12">
                        <div
                            style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }}
                            className="alert alert-secondary small-title"
                            role="alert"
                        >
                            REQUERIMIENTOS DE HABITACIONES
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover mb-0 custom-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "1%" }}>#</th>
                                        <th style={{ width: "7%" }}>FECHA IN</th>
                                        <th style={{ width: "1%" }}>FECHA OUT</th>
                                        <th style={{ width: "1%" }}>NOCHES</th>
                                        <th style={{ width: "15%" }}>DEC. HABITACIÓN</th>
                                        <th style={{ width: "1%" }}>CANT. HABITACION.</th>
                                        <th style={{ width: "5%" }}>TARIFA * NOCHE {monedaActiva}</th>
                                        <th style={{ width: "1%" }}>SUB TOTAL {monedaActiva}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formulario.requerimientoshabitaciones.map((requerimiento, index) => (
                                        <tr key={index} style={{ textAlign: "justify" }}>
                                            <td style={{ fontSize: "13px" }}>{index + 1}</td> {/* Se suma 1 al índice */}
                                            <td style={{ fontSize: "13px" }}>{requerimiento.fechin_roomreq_con}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.fechout_roomreq_con}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.noches_roomreq_con}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.dec_roomreq_con}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.cant_roomreq_con}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.tarifa_roomreq_con}</td>
                                            <td style={{ fontSize: "13px" }}>{requerimiento.sub_roomreq_con}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="text-start">
                            <hr className="mb-2 mt-1 border-secondary border-opacity-50" />
                        </div>
                    </div>
                )}
                {formulario.requerimientoshabitaciones.length > 0 && (
                    <div className="col-12">
                        <div className="invoice-total ms-auto invoiceRequerimiento">
                            {/* Bloque Subtotal */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>SUB TOTAL {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.subtsubtRoom_Subt_con}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>13% IM.VENTAS {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.trecesubtRoom_Subt_con}</p>
                                </div>
                            </div>
                            <hr className="invoice-divider" />
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>TIP MUCAMA {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.mucamasubtRoom_Subt_con}</p>
                                </div>
                            </div>

                            <hr className="invoice-divider" />
                            {/* Bloque Impuesto */}
                            <div className="invoice-row">
                                <div className="invoice-label">
                                    <p>TOTAL HABITACIONES {monedaActiva} :</p>
                                </div>
                                <div className="invoice-value">
                                    <p>{formulario.totalRequerimientos.totalsubtRoom_Subt_con}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="col-12">
                    <div
                        style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }}
                        className="alert alert-secondary small-title"
                        role="alert"
                    >
                        TOTALES GENERAL
                    </div>
                    <div className="text-start">
                        <div className="invoice-total ms-auto p-3 border rounded shadow-sm">
                            <div className="row align-items-center mb-2">
                                <div className="col-6">
                                    <p className="text-muted mb-0 text-start"> TOTAL GENERAL {monedaActiva} :</p>
                                </div>
                                <div className="col-6 text-end">
                                    <input
                                        disabled
                                        style={{ minWidth: 120, fontWeight: "bold", textAlign: "right" }}
                                        type="text"
                                        className="form-control"
                                        value={formulario.totalGlobalCotizacion}
                                    />
                                </div>
                            </div>
                        </div>
                        <hr className="mb-2 mt-1 border-secondary border-opacity-50" />
                    </div>
                </div>

                <div className="col-12">
                    <label className="form-label">Notas:</label>
                    <p className="mb-0">{formulario.notaCoti || ""}</p>
                </div>
                <br />
                <br />
                <div className="col-12 text-end d-print-none">
                    {mostrarPoliticasCortas ? (
                        <PDFGeneratorCorto formulario={formulario} nombre="Contrato_" mostrarPoliticasCortas={mostrarPoliticasCortas} />
                    ) : (
                        <PDFDownload formulario={formulario} nombre="Contrato_" mostrarPoliticasCortas={mostrarPoliticasCortas} />
                    )}
                    <button onClick={EditarCotizacion} type="button" className="btn btn-warning">
                        <i className="ti ti-pencil"></i> Editar contrato
                    </button>
                </div>

                <div className="col-12">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="mostrarPoliticas"
                            checked={mostrarPoliticasCortas}
                            onChange={manejarCambioPoliticas}
                        />
                        <label className="form-check-label" htmlFor="mostrarPoliticas">
                            Mostrar Políticas Cortas
                        </label>
                    </div>
                </div>

                {/* Mostrar las políticas basadas en el estado del checkbox */}
                {mostrarPoliticasCortas ? <PoliticasCorta formulario={formulario} /> : <PoliticasLargas formulario={formulario} />}
            </div>
        </>
    );
};
